import links from "@/links/links";

export default {
  actions: {
    GET(id) {
      return this.get(links.RECIPIENT_MEETING_DOC_GET(id));
    },
    POST(item) {
      return this.post(links.RECIPIENT_MEETING_DOC_POST(), item);
    },
    PUT(item) {
      return this.put(links.RECIPIENT_MEETING_DOC_PUT(item.id), item);
    },
    DELETE(item) {
      return this.delete(links.RECIPIENT_MEETING_DOC_DELETE(item.id), {
        delete: item.id,
      });
    },
    GET_BY_MEETING(meeting_id, save, asl = null) {
      var processedQueryParams = {};
      processedQueryParams["meeting.id"] = meeting_id;
      processedQueryParams.pagination = false;
      if (asl != null) {
        processedQueryParams["recipient.asl"] = asl;
      }
      return this.get(links.RECIPIENT_MEETING_DOC_BY_MEETING_ID(), {
        params: processedQueryParams,
        dataKey: "hydra:member",
        save,
      });
    },
    GET_FOR_ASL(queryParams) {
      var processedQueryParams = {};
      processedQueryParams.asl = 1;
      processedQueryParams.meetingId = queryParams.meetingId;
      processedQueryParams.page = queryParams.page;
      processedQueryParams.itemsPerPage = queryParams.itemsPerPage;
      processedQueryParams.orderByName = queryParams.orderByName;
      processedQueryParams.searchParams = queryParams.searchParams;

      return this.get(links.RECIPIENT_MEETING_DOC_FOR_ASL(), {
        params: processedQueryParams,
        save: false,
      });
    },
  },
};
